import { render } from "./UserResetPassword.vue?vue&type=template&id=22b45d62&ts=true"
import script from "./UserResetPassword.vue?vue&type=script&lang=ts"
export * from "./UserResetPassword.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__